import { Store } from 'vuex';
import { getModule } from 'vuex-module-decorators';

// Modules
import Flash from '@/store/modules/flash';

export let flashStore: Flash;

export function initialiseStores (store: Store<unknown>): void {
    flashStore = getModule(Flash, store);
}

export const modules = { flash: Flash };
